<script>
import utilsMixin from '@shared/mixins/utils';

export default {
  mixins: [utilsMixin],
  props: {
    isEmbed: {
      type: Boolean,
      default: false,
    },
    hasPrice: {
      type: Boolean,
      default: true,
    },
    trainingName: {
      type: String,
      default: null,
    },
    training: {
      type: Object,
      required: true,
    },
    isBuyable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    href() {
      return this.$router
        .resolve({ name: 'training', params: { slug: this.training.slug } })
        .href;
    },
    priceStyle() {
      return {
        'font-weight': this.training.discount_price != null && 400,
        'text-decoration': this.training.discount_price != null && 'line-through',
        opacity: this.training.discount_price != null && 0.7,
      };
    },
    picture() {
      if (this.training.picture && !this.training.picture.startsWith('http')) {
        return `${this.$env.apiResourcesURL}/${this.training.picture}`;
      }

      if (!this.training.picture) {
        this.$emit('img-load');
      }

      return this.training.picture;
    },
  },
  methods: {
    onClick() {
      if (!this.isBuyable) {
        return;
      }

      if (this.isEmbed) {
        window.parent.postMessage({ name: 'checkout' }, '*');
        return;
      }

      this.$router.push({ name: 'training', params: { slug: this.training.slug } });
    },
  },
  i18n: {
    messages: {
      en: {
        free: 'Free',
        view_training: 'Discover the training',
        acquired_training: 'You already have access to this training',
      },
      fr: {
        free: 'Gratuit',
        view_training: 'Voir la formation',
        acquired_training: 'Vous avez déjà accès à cette formation',
      },
    },
  },
};
</script>

<template>
  <article class="comp box">
    <div class="columns is-vcentered">
      <div class="column is-narrow">
        <figure
          class="comp_img image bradius-8"
          :class="{'cursor-pointer': isBuyable}"
          @click.prevent="onClick"
        >
          <img
            v-if="picture"
            :src="picture"
            :alt="trainingName || training.name"
            @load="$emit('img-load')"
          >
          <span v-else class="is-block p-10 has-background-light is-custom has-text-centered">
            <b-icon icon="chalkboard-teacher" size="is-large" />
          </span>
        </figure>
      </div>
      <div class="column">
        <h2 class="title is-custom is-4 is-size-6-touch">
          <component :is="isBuyable ? 'a' : 'span'"
            class="color-inherit"
            :href="href"
            @click.prevent="onClick"
          >
            {{ trainingName || training.name }}
          </component>
        </h2>
        <p v-if="training.summary" class="is-size-6 is-size-8-touch">
          {{ training.summary }}
        </p>
        <p v-if="isBuyable" class="mt-4 is-size-6 is-size-8-touch">
          <template v-if="hasPrice">
            <strong v-if="training.discount_price != null" class="mr-3 valign-middle">
              <template v-if="training.discount_price > 0">
                {{ training.discount_price | formatPrice }}
              </template>
              <template v-else>
                {{ $t('free') }}
              </template>
            </strong>
            <strong class="mr-3 valign-middle" :style="priceStyle">
              <template v-if="training.price > 0">
                {{ training.price | formatPrice }}
              </template>
              <template v-else>
                {{ $t('free') }}
              </template>
            </strong>
          </template>
          <b-button
            v-if="!training.isAcquired"
            key="training_not_acquired"
            type="is-primary is-custom valign-middle"
            tag="a"
            :href="href"
            @click.prevent="onClick"
          >
            {{ $t('view_training') }}
          </b-button>
          <p
            v-if="training.isAcquired"
            class="tag"
            v-t="'acquired_training'"
          />
      </div>
    </div>
  </article>
</template>

<style lang="scss" scoped>
.comp {
  &_img {
    width: 320px;
    max-height: 320px;

    img {
      object-fit: cover;
      object-position: center top;
    }

    .is-small & {
      width: 200px;
    }

    @include mobile {
      &,
      .is-small & {
        width: 100%;
      }
    }
  }

  .button {
    white-space: initial;

    @include mobile {
      width: 100%;
      margin-top: 20px;
    }
  }
}
</style>
